import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const MaintenanceTimeContainer = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
})